import UIStrings from '@/Utils/UIStrings';
import { percentileInTextColors } from '@/lib/utils';

export function getColorByTestValidity(value: number) {
    switch (value) {
        case 1:
        case 2:
            return percentileInTextColors.VeryLow;
        case 3:
            return percentileInTextColors.Medium;
        case 4:
            return percentileInTextColors.High;
        case 5:
            return percentileInTextColors.Top;
        default:
            return 'text-muted-foreground';
    }
}

export function getTextByTestValidity(value: number) {
    switch (value) {
        case 1:
            return UIStrings.TestValidityVeryPoor;
        case 2:
            return UIStrings.TestValidityPoor;
        case 3:
            return UIStrings.TestValidityModerate;
        case 4:
            return UIStrings.TestValidityGood;
        case 5:
            return UIStrings.TestValidityVeryGood;
        default:
            return '';
    }
}
